//WordPress API
const wpURL = process.env.REACT_APP_WORDPRESS_URL;
const ActivePlugin = 'auto-listing';

// Fetch Inventory Listings (Listings)
export async function fetchListings() {
    try {
      const response = await fetch(`${wpURL}/wp-json/wp/v2/${ActivePlugin}?_embed=true`);
      const posts = await response.json();
      return posts;
    }
    catch (error) {
      console.error('Error fetching listings:', error);
    }
};


// Fetch Car Details (Single Listing)
export async function fetchCarDetails(id) {
    try {
      const response = await fetch(`${wpURL}/wp-json/wp/v2/${ActivePlugin}/${id}?_embed=true`);
      const post = await response.json();
      return post;
    }
    catch (error) {
      console.error('Error fetching car details:', error);
    }
};